import { defineComponent as o } from "vue";
import { screenSizeDetection as r } from "@sunrise/shared";
import t from "./index565.js";
const s = o({
  name: "MsHeaderLogo",
  components: {
    MsLogo: t
  },
  props: {
    href: String,
    channelName: String
  },
  setup(e) {
    function n() {
      return e.channelName !== "Bereich wählen";
    }
    return {
      ...r(),
      showLabel: n
    };
  }
});
export {
  s as default
};
